import AlertErrorsContainer from './alert-errors-container';

export default AlertErrorsContainer;
